(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-product-resource-tabs]');
  if (!roots.length) return;

  var normalize = function (value) {
    return String(value || '').trim().toLowerCase();
  };

  var splitTags = function (value) {
    return String(value || '').split('||').map(normalize).filter(Boolean);
  };

  var intersects = function (actualValues, expectedValues, contains) {
    var actual = actualValues.map(normalize).filter(Boolean);
    var expected = (expectedValues || []).map(normalize).filter(Boolean);
    return expected.some(function (wanted) {
      return actual.some(function (value) {
        return contains ? value.indexOf(wanted) !== -1 : value === wanted;
      });
    });
  };

  var ruleMatches = function (rule, product) {
    var match = rule.match || {};
    var checks = [];
    if (match.catalogFamily) checks.push(intersects([product.catalogFamily], match.catalogFamily, false));
    if (match.series) checks.push(intersects([product.series], match.series, false));
    if (match.sourceHierarchy) checks.push(intersects([product.sourceHierarchy], match.sourceHierarchy, false));
    if (match.manufacturerBrand) checks.push(intersects([product.manufacturerBrand], match.manufacturerBrand, false));
    if (match.tags) checks.push(intersects(product.tags, match.tags, false));
    if (match.vendorContains) checks.push(intersects([product.vendor], match.vendorContains, true));
    return checks.length > 0 && checks.some(Boolean);
  };

  var dedupeResources = function (resources) {
    var seen = {};
    return resources.filter(function (resource) {
      var key = normalize(String(resource.url || '').replace(/\/$/, ''));
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  };

  var buildSelection = function (manifest, product) {
    var specific = [];
    var fallback = [];
    (manifest.rules || []).forEach(function (rule) {
      if (!ruleMatches(rule, product)) return;
      if (rule.fallbackOnly) fallback.push(rule);
      else specific.push(rule);
    });
    var matched = specific.length ? specific : fallback.slice(0, 1);
    if (!matched.length) return manifest.default;

    var resources = [];
    var notices = [];
    var sourceNotes = [];
    matched.forEach(function (rule) {
      resources = resources.concat(rule.resources || []);
      if (rule.notice && notices.indexOf(rule.notice) === -1) notices.push(rule.notice);
      if (rule.sourceNote && sourceNotes.indexOf(rule.sourceNote) === -1) sourceNotes.push(rule.sourceNote);
    });
    return {
      heading: matched[0].heading || 'Product resources',
      notice: notices.join(' '),
      sourceNote: sourceNotes.join(' '),
      resources: dedupeResources(resources),
      matchedRuleIds: matched.map(function (rule) { return rule.id; })
    };
  };

  var resourceMarkup = function (selection) {
    var wrapper = document.createElement('div');
    wrapper.className = 'tx-resources__inner';

    var heading = document.createElement('h2');
    heading.className = 'tx-resources__heading';
    heading.textContent = selection.heading || 'Product resources';
    wrapper.appendChild(heading);

    if (selection.notice) {
      var notice = document.createElement('p');
      notice.className = 'tx-resources__notice';
      notice.textContent = selection.notice;
      wrapper.appendChild(notice);
    }

    var list = document.createElement('ul');
    list.className = 'tx-resources__list';
    (selection.resources || []).forEach(function (resource) {
      var item = document.createElement('li');
      item.className = 'tx-resources__item';

      var badge = document.createElement('span');
      badge.className = 'tx-resources__type';
      badge.textContent = resource.typeLabel || 'Resource';
      item.appendChild(badge);

      var link = document.createElement('a');
      link.className = 'tx-resources__link';
      link.href = resource.url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = resource.title;
      item.appendChild(link);

      if (resource.documentNumber) {
        var doc = document.createElement('span');
        doc.className = 'tx-resources__document';
        doc.textContent = resource.documentNumber;
        item.appendChild(doc);
      }

      if (resource.scope) {
        var scope = document.createElement('p');
        scope.className = 'tx-resources__scope';
        scope.textContent = resource.scope;
        item.appendChild(scope);
      }
      list.appendChild(item);
    });
    wrapper.appendChild(list);

    if (selection.sourceNote) {
      var sourceNote = document.createElement('p');
      sourceNote.className = 'tx-resources__source-note';
      sourceNote.textContent = selection.sourceNote;
      wrapper.appendChild(sourceNote);
    }

    var help = document.createElement('p');
    help.className = 'tx-resources__help';
    help.innerHTML = 'Need a different document? <a href="mailto:Sales@TriplexSales.com?subject=Product%20resource%20request">Ask Triplex for the correct manual, brochure or parts list.</a>';
    wrapper.appendChild(help);
    return wrapper;
  };

  var activateTab = function (root, nextButton, focus) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    buttons.forEach(function (button) {
      var selected = button === nextButton;
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
      button.setAttribute('tabindex', selected ? '0' : '-1');
      var panel = root.querySelector('#' + button.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    if (focus) nextButton.focus();
  };

  var wireTabs = function (root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () { activateTab(root, button, false); });
      button.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = buttons[(index + 1) % buttons.length];
        if (event.key === 'ArrowLeft') next = buttons[(index - 1 + buttons.length) % buttons.length];
        if (event.key === 'Home') next = buttons[0];
        if (event.key === 'End') next = buttons[buttons.length - 1];
        if (next) {
          event.preventDefault();
          activateTab(root, next, true);
        }
      });
    });
  };

  roots.forEach(function (root) {
    wireTabs(root);
    var panel = root.querySelector('[data-product-resources-panel]');
    if (!panel) return;
    var product = {
      catalogFamily: root.getAttribute('data-catalog-family'),
      series: root.getAttribute('data-series'),
      sourceHierarchy: root.getAttribute('data-source-hierarchy'),
      manufacturerBrand: root.getAttribute('data-manufacturer-brand'),
      vendor: root.getAttribute('data-vendor'),
      tags: splitTags(root.getAttribute('data-tags'))
    };
    var manifestUrl = root.getAttribute('data-resource-manifest-url');
    fetch(manifestUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Resource manifest request failed');
        return response.json();
      })
      .then(function (manifest) {
        var selection = buildSelection(manifest, product);
        panel.innerHTML = '';
        panel.appendChild(resourceMarkup(selection));
        panel.setAttribute('data-resource-rules', (selection.matchedRuleIds || ['default']).join(','));
        root.classList.add('tx-product-tabs--ready');
      })
      .catch(function () {
        root.classList.add('tx-product-tabs--error');
      });
  });
}());
